import PressRoomNewsService from '../services/pressRoomNews.service';
import { SETTINGS } from 'common/consts/kentico';

import { observable, action, decorate } from 'mobx';

class PressRoomNewsStore {
  latestSearches = new Map();
  otherPressRoomNews = [];

  latestState = {
    data: [],
    page: 1,
    isExploited: false,
    category: '',
    publishYear: {
      value: ''
    }
  };

  async fetchLatestPressRoomNews(criteria) {
    const { limit = SETTINGS.DEFAULT_LIMIT, page = 1, category } = criteria;
    const publishYear = criteria.publishYear.value;

    const cacheKey = JSON.stringify({
      category,
      publishYear,
      page,
      limit
    });

    if (this.latestState.data.length) {
      return {
        isExploited: this.latestState.isExploited,
        data: this.latestState.data,
        category: this.latestState.category,
        publishYear: this.latestState.publishYear
      };
    }

    const cachedSearch = this.latestSearches.get(cacheKey);

    if (cachedSearch) {
      return cachedSearch;
    }

    try {
      const items = await PressRoomNewsService.fetchPressRoomNews({
        limit,
        page,
        category,
        publishYear
      });

      if (items.isEmpty) {
        return {
          isExploited: true,
          data: []
        };
      }

      const isNextPage = !!items.pagination.nextPage;

      const data = {
        isExploited: !isNextPage,
        data: items.items
      };

      this.latestSearches.set(cacheKey, data);

      return data;
    } catch (e) {
      console.error('Failed to fetch featured press articles data', e);
      return null;
    }
  }

  /**
   * Fetch other PressRoom News
   * @param { object } options
   *    { string } language (optional) Language of the content,
   *    { number } limit (optional) limit of items in response
   *
   * @returns { otherPressRoomNews[] } Promise resolved to array of other PressRoom News
   */
  async fetchOtherPressRoomNews({ limit = SETTINGS.DEFAULT_LIMIT } = {}) {
    if (this.otherPressRoomNews.length > 0) {
      return this.otherPressRoomNews;
    }

    try {
      const items = await PressRoomNewsService.fetchPressRoomNews({
        limit,
        page: 1,
        featured: true
      });

      if (!items.isEmpty) {
        this.otherPressRoomNews = items.items;
      }
    } catch (e) {
      console.error('Failed to fetch featured case studies data', e);
      return [];
    }
    return this.otherPressRoomNews;
  }

  /**
   * Get PressRoom news item by id
   * @param { number } id
   * @returns { pressRoomNewsItem } Prommise resolved PressRoom news item
   */
  async getPressRoomNewsItemById(id) {
    try {
      const items = await PressRoomNewsService.getPressRoomNewsItemById(id);
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch press room news item data');
      return null;
    }
  }

  async getPressRoomNewsItemBySlug(slug, lang) {
    try {
      const items = await PressRoomNewsService.getPressRoomNewsItemBySlug(
        slug,
        lang
      );
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch press room news item data by slug');
      return null;
    }
  }
}

decorate(PressRoomNewsStore, {
  searches: observable,
  otherPressRoomNews: observable,
  fetchArticles: action
});

export default new PressRoomNewsStore();



// WEBPACK FOOTER //
// ./src/stores/PressRoomNews.store.js